<div class="content-width">
  <div>
    <span class="pageHeader" id="postPurchaseUpdateHeader">
			{{pageHeader}}
	  </span>
  </div>
  <br><br><br>
  <div class="error-container" *ngIf="showErrorDiv">
    <p> {{errHeading}}</p>

    <ul class="circle">
      <li class="errorMessageStyle" *ngFor="let errorMessage of validationMessages">{{errorMessage}}</li>
    </ul>

  </div>
  <div *ngIf="isUpdateForm">
  <span class="adminTblAlign alignSpace">
        <div class="lblAlign "> Fannie Mae Loan Number:  </div>
        <div class="alignSpace"> {{loanNumber}}        </div>
  </span>
    <br>


    <table class=" alignSpace">
      <tr>
        <th class="table-header"> LOAN INFORMATION</th>
      </tr>
      <tr>
        <td class="headerFont"> Lender Loan Id</td>
        <td class="aRight"> {{lenLnIdVal}}</td>
        <td class="aLeft"><input type="text" fmTextInput [(ngModel)]="lendrLnId" maxlength="10"
                                 (keypress)="numberOnly($event)"></td>
      </tr>
      <tr>
        <td class="headerFont">Old Fannie Mae Loan#</td>
        <td class="aRight"> {{oldFnmaeLnIdVal}}</td>
        <td class="aLeft"><input type="text" fmTextInput [(ngModel)]="oldFannieLn" maxlength="10"
                                 (keypress)="numberOnly($event)"></td>
      </tr>
      <tr>
        <td class="headerFont"> FHA Case Number</td>
        <td class="aRight">  {{fhaCaseNoVal}}</td>
        <td class="aLeft"><input type="text" fmTextInput [(ngModel)]="fhaCaseNum" maxlength="13"
                                 (keypress)="numberOnly($event)"></td>
      </tr>

      <tr>
        <th class="table-header"> PROPERTY INFORMATION</th>
      </tr>
      <tr>
        <td class="headerFont"> Address</td>
        <td class="aRight">  {{addVal}}</td>
        <td class="aLeft"><input type="text" fmTextInput [(ngModel)]="address" maxlength="32"></td>
      </tr>
      <tr>
        <td class="headerFont">City</td>
        <td class="aRight"> {{cityVal}}</td>
        <td class="aLeft"><input type="text" fmTextInput [(ngModel)]="city" maxlength="15"></td>
      </tr>
      <tr>
        <td class="headerFont"> State</td>
        <td class="aRight"> {{stateVal}}</td>
        <td class="aLeft">
          <fm-select
            placeholder="Choose"
            [options]="state"
            [(ngModel)]="selectedState"
            ariaLabelledBy="default"
            class="width:80%"

          ></fm-select>
        </td>
      </tr>
      <tr>
        <td class="headerFont"> ZIP</td>
        <td class="aRight"> {{zipVal}}</td>
        <td class="aLeft"><input type="text" fmTextInput [(ngModel)]="zip" maxlength="5"
                                 (keypress)="numberOnly($event)"></td>
      </tr>
      <tr>
        <td class="headerFont"> Year House Built</td>
        <td class="aRight"> {{yrHouBuiltVal}}</td>
        <td class="aLeft"><input type="text" fmTextInput [(ngModel)]="yrBuilt" maxlength="4"
                                 (keypress)="numberOnly($event)"></td>
      </tr>
      <tr>
        <td class="headerFont"> Number of Bedrooms</td>
        <td class="aRight"> {{noOfBedRmVal}}</td>
        <td class="aLeft"><input type="text" fmTextInput [(ngModel)]="noOfRoom" maxlength="2"
                                 (keypress)="numberOnly($event)"></td>
      </tr>
      <tr>
        <td class="headerFont"> Number of Units</td>
        <td class="aRight"> {{noOfUnitVal}}</td>
        <td class="aLeft">
          <fm-select
            [options]="units"
            [(ngModel)]="selectedUnit"
            ariaLabelledBy="default"
            placeholder="Choose"
          ></fm-select>
        </td>
      </tr>
      <tr>
        <td class="headerFont">Dwelling Type</td>
        <td class="aRight"> {{dwelTypeVal}}</td>
        <td class="aLeft">
          <fm-select
            [options]="dwelType"
            [(ngModel)]="selectedDwel"
            placeholder="Choose"
            ariaLabelledBy="default"
          ></fm-select>
        </td>
      </tr>

      <tr>
        <th class="table-header"> BORROWER INFORMATION</th>
      </tr>
      <tr>
        <td class="headerFont"> Monthly Income</td>
        <td class="aRight"> ${{monIncmVal | number : '1.2-2'}}</td>
        <td class="aLeft"><input type="text" fmTextInput [(ngModel)]="monIncome" maxlength="12"
                                 (keypress)="numberOnly($event)"></td>
      </tr>
      <tr>
        <td class="headerFont">Borrower Ethnicity</td>
        <td class="aRight"> {{borrEthnicityVal}}</td>
        <td class="aLeft">
          <fm-select
            placeholder="Choose"
            [options]="borEthnicity"
            [(ngModel)]="selectedBorEthnicity"
            ariaLabelledBy="default"
          ></fm-select>
        </td>
      </tr>
      <tr>
        <td class="headerFont">Borrower Gender</td>
        <td class="aRight"> {{displayBorrGendVal}}</td>
        <td class="aLeft">
          <fm-select
            placeholder="Choose"
            [options]="borGender"
            [(ngModel)]="selectedBorGender"
            ariaLabelledBy="default"
          ></fm-select>
        </td>
      </tr>
      <tr>
        <td class="headerFont">Borrower Race</td>
        <td class="aRight"> {{borrRaceVal}}</td>
        <td class="aLeft">
          <fm-select
            placeholder="Choose"
            [options]="borRace"
            [(ngModel)]="selectedBorRace"
            ariaLabelledBy="default"
          ></fm-select>
        </td>
      </tr>


      <tr>
        <th class="table-header">CO-BORROWER INFORMATION</th>
      </tr>

      <tr>
        <td class="headerFont">Co-Borrower Ethnicity</td>
        <td class="aRight"> {{coBorrEthniVal}}</td>
        <td class="aLeft">
          <fm-select
            placeholder="Choose"
            [options]="coBorEthnicity"
            [(ngModel)]="selectedCoBorEthnicity"
            ariaLabelledBy="default"
          ></fm-select>
        </td>
      </tr>
      <tr>
        <td class="headerFont">Co-Borrower Gender</td>
        <td class="aRight"> {{coBorrgenVal}}</td>
        <td class="aLeft">
          <fm-select
            placeholder="Choose"
            [options]="CoBorGender"
            [(ngModel)]="selectedCoBorGender"
            ariaLabelledBy="default"
          ></fm-select>
        </td>
      </tr>
      <tr>
        <td class="headerFont">Co-Borrower Race</td>
        <td class="aRight"> {{coBorrRaceVal}}</td>
        <td class="aLeft">
          <fm-select
            placeholder="Choose"
            [options]="coBorRace"
            [(ngModel)]="selectedCoBorRace"
            ariaLabelledBy="default"
          ></fm-select>
        </td>
      </tr>
      <tr>
        <td class="headerFont">Co-Borrower Date of Birth</td>
        <td class="aRight"> {{coBorrDobVal}}</td>
        <td class="aLeft"><input type="text" fmTextInput [(ngModel)]="coBoDOB" maxlength="10"
                                 (keypress)="dateFormatOnly($event)"></td>
      </tr>
    </table>
    <div class="btnAlign">
      <button fmButton type="button" routerLink="/postPurchaseAdj" [small]="true" label="Cancel"
              class="dispbuttonMargin"></button>
      <button fmButton type="button" [small]="true" label="Clear" (click)="clearBtn()"
              class="dispbuttonMargin"></button>
      <button fmButton type="button" [small]="true" label="Update" (click)="updateConfirmBtn()" [primary]="true"
              class="dispbuttonMargin"></button>
    </div>
  </div>
  <div *ngIf="isUpdateConfirm">
    <span class="adminTblAlign alignSpace">
        <div class="lblAlign "> Fannie Mae Loan Number:  </div>
        <div class="alignSpace"> {{loanNumber}}        </div>
    </span>
    <div class="ui-g-12" *ngFor="let col of updatePostPurchaseValues">
      <div class="ui-g-4 displayTopic">{{col.name}}</div>
      <div class="ui-g-4 ">{{col.currentVal}}</div>
      <div class="ui-g-4 ">{{col.newVal}} </div>
    </div>
    <div class="btnAlignUpdateCancel">
      <button fmButton type="button" (click)="cancelConfirmBtn()" [small]="true" label="Cancel"
              class="dispbuttonMargin"></button>
      <button fmButton type="button" [small]="true" label="Update" (click)="updateData()"
              [primary]="true" class="dispbuttonMargin"></button>
    </div>
  </div>
</div>
<br>
